<template>
	<div class="pa-3">
		<v-container fluid style="max-width: 500px">
			<v-row>
				<v-col
					v-for="card in userCards"
					:key="card.Id"
					cols="12"
				>
					<v-container
						class="blue-grey lighten-4 pa-4 mb-4 elevation-4"
						style="border-radius: 8px"
					>
						<v-row>
							<v-col cols="1">
								<v-img
									:src="getCardIcon(card.Brand)"
									max-width="60"
									contain
									style="display: inline-block"
									class="mb-5"
								>
								</v-img>
							</v-col>
							<v-col>
								<div class="text-right">
									<span
										class="card-number"
										style="display: inline-block;"
									>
										.... .... .... {{ card.Last4 }}
									</span>
									<br />
									<span
										style="font-size: 0.7rem"
										class="mr-2"
									>
										scadenza:</span
									>
									<span class="card-number"
										>{{ card.ExpiryMonth }}/{{
											card.ExpiryYear
										}}
									</span>
								</div>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<div class="text-right">
									<span v-if="!card.IsDefault" class="mr-4">
										<v-icon
											size="18"
											@click="
												DeletePaymentMethod(card.Id)
											"
											>fas fa-trash</v-icon
										>
									</span>
									<span v-if="userCards.length > 1">
										<!--					-->
										<v-icon
											size="20"
											color="orange"
											v-if="!card.IsDefault"
											@click="
												SetDefaultPaymentMethod(card.Id)
											"
											>far fa-star</v-icon
										>
										<v-icon
											size="20"
											color="orange"
											v-if="card.IsDefault"
											>fa fa-star</v-icon
										>
									</span>
								</div>
							</v-col>
						</v-row>
					</v-container>
				</v-col>
				<v-col cols="12">
					<StripeAddPaymentMethod
						@card-verified="LoadPaymentMethods"
					></StripeAddPaymentMethod
				>

					<div>
						<v-img
							src="https://nutriyouweb.blob.core.windows.net/nutriyouweb/LandingPages/Payment/Stripe.png"
							max-width="60"
							contain
						>
						</v-img>
						I dati della tua carta di credito sono elaborati e
						conservati in modo sicuro da Stripe.
					</div>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>
<script>
import CrudClient from "@/services/CrudClient";
import StripeAddPaymentMethod from "@/views/Patients/components/StripeAddPaymentMethod.vue";

export default {
	name: "StripePaymentMethods",
	components: { StripeAddPaymentMethod },
	data() {
		return {
			userCards: null,
			paymentIconMap: {
				visa:
					"https://nutriyouweb.blob.core.windows.net/nutriyouweb/LandingPages/Payment/Visa.png",
				mastercard:
					"https://nutriyouweb.blob.core.windows.net/nutriyouweb/LandingPages/Payment/mastercard.png",
				stripe:
					"https://nutriyouweb.blob.core.windows.net/nutriyouweb/LandingPages/Payment/Stripe.png",
				paypal:
					"https://nutriyouweb.blob.core.windows.net/nutriyouweb/LandingPages/Payment/Paypal.png",
				"apple pay":
					"https://nutriyouweb.blob.core.windows.net/nutriyouweb/LandingPages/Payment/ApplePay.png",
				"google pay":
					"https://nutriyouweb.blob.core.windows.net/nutriyouweb/LandingPages/Payment/GooglePay.png"
				// amex: "fab fa-cc-amex",
				// "american express": "fab fa-cc-amex",
				// discover: "fab fa-cc-discover",
				// diners: "fab fa-cc-diners-club",
				// "diners club": "fab fa-cc-diners-club",
				// jcb: "fab fa-cc-jcb",
				// unionpay: "fab fa-cc-stripe", // No specific icon for UnionPay

				// default: "far fa-credit-card" // Default icon for unknown card types
			}
		};
	},
	created() {
		this.StripePaymentsService = new CrudClient("StripePayments");
	},
	async mounted() {
		await this.LoadPaymentMethods();
	},
	methods: {
		getCardIcon(brand) {
			// Convert brand name to lowercase for case-insensitive lookup
			const brandLower = brand.toLowerCase();
			// Return the matching icon or the default icon if not found
			return (
				this.paymentIconMap[brandLower] || this.paymentIconMap.default
			);
		},

		async LoadPaymentMethods() {
			this.userCards = await this.StripePaymentsService.Get(
				null,
				"SavedPaymentMethods"
			);
		},

		async DeletePaymentMethod(id) {
			this.$log.debug("DeletePaymentMethod" + id);

			await this.StripePaymentsService.Delete(
				null,
				"PaymentMethod/" + id
			);

			this.userCards = await this.StripePaymentsService.Get(
				null,
				"SavedPaymentMethods"
			);
		},

		async SetDefaultPaymentMethod(id) {
			this.$log.debug("SetDefaultPaymentMethod" + id);

			await this.StripePaymentsService.Post(
				null,
				null,
				`PaymentMethod/${id}/SetDefault`
			);

			this.userCards = await this.StripePaymentsService.Get(
				null,
				"SavedPaymentMethods"
			);
		}
	}
};
</script>

<style scoped lang="scss">
.card-number {
	font-family: "OCR-A", monospace;
	letter-spacing: 1px;
}
</style>
